<template>
  <v-toolbar flat>
    <v-dialog
      v-if="listButton.formDateRange"
      ref="rangeDateDialog"
      v-model="rangeDateDialog"
      :return-value.sync="filter.trx_datetime"
      persistent
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          id="rangeDate"
          prepend-inner-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          v-model="dateRangeText"
          :label="listButton.formDateRange.label"
          hide-details="true"
        >
          <template v-slot:append-outer>
            <v-btn large text color="orange" @click="showData">
              <v-icon left> mdi-magnify </v-icon>search
            </v-btn>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="filter.trx_date"
        scrollable
        range
        :min="minDate"
        :max="maxDate"
      >
        <v-spacer />
        <v-btn text color="primary" @click="rangeDateDialog = false">
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="
            () => {
              checkRangeDate();
              $refs.rangeDateDialog.save(filter.trx_date);
            }
          "
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <v-spacer />
    <template>
      <div class="d-flex align-content-center flex-wrap">
        <div class="d-flex align-content-center flex-wrap">
          <v-switch
            v-if="showFilterCh"
            class="mr-4"
            v-model="switchChData"
            inset
            :label="`${switchChData ? 'Main Data' : 'Secondary Data'} `"
            label-position="left"
            hide-details="true"
          ></v-switch>
        </div>
        <div class="d-flex align-content-center flex-wrap">
          <v-btn
            v-if="listButton.buttonAdd"
            color="primary"
            dark
            class="mr-2"
            @click="addItem"
          >
            {{ listButton.buttonAdd.label }}
          </v-btn>
          <v-btn
            v-if="listButton.buttonRemove"
            color="error"
            dark
            class="mr-2"
            @click="removeItem"
          >
            {{ listButton.buttonRemove.label }}
          </v-btn>

          <v-btn
            v-if="listButton.buttonRestart"
            color="warning"
            icon
            @click="getData"
            :loading="loading"
            :disabled="loading"
            class="mr-2"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
        </div>

        <v-menu
          v-if="listButton.buttonDots"
          offset-y
          rounded="lg"
          transition="slide-y-transition"
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="warning" icon dark v-bind="attrs" v-on="on">
              <v-icon light size="20">mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <div v-if="listButton.buttonDotsExt">
              <v-list-item
                link
                v-for="(item, index) in listButton.buttonDotsExt"
                :key="index"
                @click="getAction(item.link, item.voidStatus)"
                v-show="item.show"
              >
                <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </div>
          </v-list>
        </v-menu>
      </div>
    </template>
  </v-toolbar>
</template>

<script>
import { dataMinRangeDate, dataMaxRangeDate } from '../../store/params';
import { getDate } from '../../lib/helpers';

export default {
  props: ['listButton', 'loading', 'selectedData', 'switchCh'],
  data: () => ({
    today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10),
    rangeDateDialog: false,
    filter: {
      trx_date: [],
    },
  }),
  computed: {
    switchChData: {
      set(val) {
        this.$emit('onSwitch', val);
      },
      get() {
        return this.switchCh;
      },
    },
    showFilterCh() {
      return (
        this.listButton.buttonSwitchCh &&
        JSON.parse(process.env.VUE_APP_FILTER_CH)
      );
    },
    dateRangeText() {
      return this.filter.trx_date.join(' ~ ');
    },
    minDate() {
      if (this.filter.trx_date.length > 0) {
        const tempMinDate = Date.parse(this.filter.trx_date[0]);
        return this.getDate(dataMinRangeDate, tempMinDate);
      }
      return '';
    },
    maxDate() {
      if (this.filter.trx_date.length > 0) {
        const tempMaxDate = Date.parse(this.filter.trx_date[0]);
        const maxDate = this.getDate(dataMaxRangeDate, tempMaxDate);
        return maxDate > this.today ? this.today : maxDate;
      }
      return this.today;
    },
  },
  methods: {
    getAction(link, voidStatus) {
      if (voidStatus) {
        this.$emit(link);
      } else {
        this.$router.push({
          path: link,
        });
      }
    },
    showData() {
      this.$emit('showDataParent', this.filter.trx_date);
    },
    getData() {
      this.$emit('getDataParent');
    },
    checkRangeDate() {
      if (this.filter.trx_date.length == 1) {
        this.filter.trx_date.push(this.filter.trx_date[0]);
      }
    },
    exportItem() {
      this.$emit('exportItemParent');
    },
    addItem() {
      this.$emit('addItemParent');
    },
    removeItem() {
      this.$emit('removeItemParent');
    },
    getDate,
  },
};
</script>
